module.exports = __webpack_public_path__ + "img/group-gray.0f53b7aa.svg";